import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getTenantConfig } from '../services/tenantservice';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const { tenantSlug } = useParams();
  const navigate = useNavigate();
  const [tenantConfig, setTenantConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTenantConfig = async () => {
      if (!tenantSlug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        // Fetch tenant configuration
        const config = await getTenantConfig(tenantSlug);
        setTenantConfig(config);
      } catch (err) {
        console.error('Error fetching tenant config:', err);
        setError(err.message || 'Failed to load tenant configuration');
        setTenantConfig(null);
        navigate('/Sunrise', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    fetchTenantConfig();
  }, [tenantSlug]);

  const value = {
    tenantSlug,
    tenantConfig,
    loading,
    error,
  };

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  );
};

export default TenantContext;
